export default __webpack_public_path__ + "static/media/monkey_black_female.0ff1b0e5.png";